/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	BudgetPredictionGetPredictionRequest,
	BudgetPredictionGetPredictionResponse,
} from '../types/BudgetPredictionGetPrediction'

/**
 * POST /budget-prediction
 * @see backend/nexus/modules/Campaign/Http/Controllers/BudgetPredictionController.php BudgetPredictionController::getPrediction
 */
export async function budgetPredictionGetPrediction(
	data: BudgetPredictionGetPredictionRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<BudgetPredictionGetPredictionResponse>> {
	return axiosInstance.post('/budget-prediction', data, config)
}
